export default "__VITE_ASSET__7f392550__"